module.exports = __webpack_public_path__ + "media/honey-icons/icon-help-821bcc24.svg";